<template>
  <v-layout align-start row class="sc-message">
      <!-- show typing messages -->
      <div v-if="message.type === types.TypingMessage" class="sc-message--content">

        <!-- TODO: move this shit into TypingMessage -->
        <div class="sc-message--avatar" v-if="!$store.state.currentChat.single">
          <user-avatar 
            :avatar="message.avatar"
            :username="message.author" 
            :size="40"
          />
        </div>
        <div class="sc-message--data">
          <v-layout v-if="!$store.state.currentChat.single">
            <span class='sc-message--name'>{{message.author}}</span>
          </v-layout>
          <TypingMessage />
        </div>

      </div>

      <!-- show system message -->
      <div v-else-if="isSystemMessage()" class="sc-message--content system bubble">
        <SystemMessage :message="message" />
      </div>

      <!-- else show normal message -->
      <div v-else :class="'sc-message--content ' + sentClass">
        
        <!-- show avatars only in group chats -->
        <div v-if ="!this.$store.state.currentChat.single" class="sc-message--avatar">
          <user-avatar 
            :avatar="avatar"
            :username="message.authorName" 
            :size="40"
            v-if="showAuthor"
          />
          <div v-else style="margin-right:40px;">
          </div>
        </div>
        
        <div @contextmenu="showContextMenu" class="sc-message--data">
          <!-- message header -->
          <div v-if="!message.sent && !this.$store.state.currentChat.single && showAuthor">
            <span class='sc-message--name'>{{message.authorName}}</span>
          </div>

          <div class="bubble">
            <message-quote v-if="hasReply"
              :message="message.data.reply"
            ></message-quote>

            <TextMessage v-if="message.type == this.types.TextMessage" 
              :time="getTime"
              :message="message"
            />
            
            <FileMessage v-else-if="message.type == this.types.DocumentMessage" 
              :message="message" 
            />
            <ImageMessage v-else-if="message.type == this.types.ImageMessage" 
              :message="message"
              :progress="progress"
            />

            <VideoMessage v-else-if="message.type == this.types.VideoMessage"
              :message="message"
            />
            <LocationMessage v-else-if="message.type == this.types.LocationMessage"
              :message="message"
            />
            <ContactMessage v-else-if="message.type == this.types.ContactMessage"
              :contact="message.data" 
              :state="message.sent ? message.state : null" 
              :time="getTime"
              :mid="message.id"
            />
            <AudioMessage v-else-if="message.type == this.types.AudioMessage"
              :message="message"
            />
            <RemoveMessage v-else-if="message.type == this.types.RemoveMessage" 
              :text="message.content"
              :sent="message.sent"
            />
          </div>
        </div> 
      </div>
  </v-layout>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  import timeUtils from '@utils/timeUtils'

  import TextMessage from './TextMessage.vue'
  import FileMessage from './FileMessage.vue'
  import ImageMessage from './ImageMessage.vue'
  import VideoMessage from './VideoMessage.vue'
  import LocationMessage from './LocationMessage.vue'
  import ContactMessage from './ContactMessage.vue'
  import TypingMessage from './TypingMessage.vue'
  import SystemMessage from './SystemMessage.vue'
  import AudioMessage from './AudioMessage.vue'
  import RemoveMessage from './RemoveMessage.vue'
  import MessageQuote from './MessageQuote.vue'
  import UserAvatar from '@common/UserAvatar.vue'

  export default {
    data () {
      return {
        avatar: ''
      }
    },
    components: {
      TextMessage,
      FileMessage,
      ImageMessage,
      VideoMessage,
      LocationMessage,
      ContactMessage,
      TypingMessage,
      SystemMessage,
      AudioMessage,
      RemoveMessage,
      UserAvatar,
      MessageQuote
    },
    props: {
      message: {
        type: Object,
        required: true
      },
      messagePrev: Object,
      progress: {
        type: Number,
        required: false
      }
    },
    mounted() {
      // TODO: quick fix, do we need better optimization to get avatar?
      if (!this.$store.state.currentChat.single && !this.message.sent) {
        let messageWithAvatar = this.message.type !== this.types.TypingMessage && !this.isSystemMessage()
        if (messageWithAvatar && this.showAuthor) {
          this.avatar = this.$store.getters.getContactAvatar(this.message.author)
        }
      }
    },
    methods: {
      showContextMenu() {
        if (this.message.type === this.types.RemoveMessage)
          return
        event.preventDefault()
        EventBus.$emit('show-context-menu', {
          x: event.pageX,
          y: event.pageY,
          message: this.message
        })
      },
      isSystemMessage() {
        const systemMessages = [this.types.TimerMessage, this.types.DateMessage, 
                              this.types.UserAddedMessage, this.types.UserLeftMessage,
                              this.types.ChatDetailsMessage]
        return (systemMessages.indexOf(this.message.type)>-1)
      }
    },
    computed: {
      getTime() {
        return timeUtils.getShortTime(this.message.time);
      },
      sentClass() {
        return this.message.sent ? 'sent' : 'recv'
      },
      bubbleClass() {
        return this.message.sent ? 'sent' : 'recv'
      },
      showAuthor() {
        return (this.messagePrev == null) ? true : this.messagePrev.author !== this.message.author
      },
      hasReply() {
        return this.message.data && this.message.data.reply
      }
    }
  }
</script>

<style>
  .sc-message {
    padding: 0 32px;
    /*max-width: 1000px;
    margin: 0 auto;*/
  }

  .sc-message--content {
    width: 100%;
    display: flex;
    padding: 1px 0;
  }

  .sc-message--content.sent {
    justify-content: flex-end;
  }
  .sc-message--content.sent .sc-message--avatar {
    display: none;
  }

  .sc-message--content.system {
    justify-content: center;
    padding: 4px 0;
  }

  .sc-message--avatar {
    margin-right: 5px;
    margin-top: 15px;
  }

  .sc-message--data {
    max-width:64%;
  }
  .sc-message--data .sc-message--name {
    margin-top: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }

  .sc-message--content.recv .bubble {
    background-color: var(--recv-message-background);
    border-radius:5px;
    width: fit-content !important;
  }

  .sc-message--content.sent .bubble {
    background-color: var(--sent-message-background);
    border-radius:5px;
  }

  .sc-message--data .bubble-box {
    padding: 4px 16px;
    box-sizing:border-box;
  }

  .bubble-box .text-with-pad {
    position: relative;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .recv .bubble-box .text-with-pad::after {
    margin-right: 36px;
  }
  .sent .bubble-box .text-with-pad::after {
    margin-right: 52px;
  }

  .bubble-box .text-with-pad::after {
    content: "";
    display: inline;
  }

  /* commmon for image and video */
  .sc-message--preview {
    width: 250px;
    height: 150px;
    z-index: 3;
    background-repeat: no-repeat;
    background-position: center;
    background-position-x: center;
    opacity: 1;
    background-size: 100% 100%;
    border-radius: inherit;
  }
  .sc-message--preview:hover {
    opacity:0.8;
  }
  .sc-message--preview-icon {
    width:inherit; 
    height:inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:10;
  }
  .sc-message--preview-state {
    /* align to the same position with text message state */
    position: relative;
    right: 16px;
    bottom: 4px;    
  }
</style>
